import appClient from '../../common/services/AppClient';
import { HistoryData } from '../types/History';

export default class HistoryService {
    async getHistory(projectId: string) {
        const url = `${process.env.REACT_APP_SERVICE_URL}projects/${projectId}/history`;
        const resp = await appClient.get<HistoryData[]>(url);
        return resp.unwrapOr(Array<HistoryData>());
    }
}